import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from '@/components/LoginPage.vue'
import RegistrationPage from '@/components/RegistrationPage.vue'
import EmailVerificationPage from '@/components/EmailVerificationPage.vue'
import StudentDashboard from '@/components/StudentDashboard.vue'
import TeacherDashboard from '@/components/TeacherDashboard.vue'
import ParentDashboard from '@/components/ParentDashboard.vue'

// Additional pages used by StudentDashboard navigation
import RewardsPage from '@/components/RewardsPage.vue'
import LibraryPage from '@/components/LibraryPage.vue'
import ActivityPage from '@/components/ActivityPage.vue'
import LanguageLearningPage from '@/components/LanguageLearningPage.vue'
import PuzzleGame from '@/components/PuzzleGame.vue'
import ReflectionPage from '@/components/ReflectionPage.vue'
import ChallengeDetail from '@/components/ChallengeDetail.vue'
import TaskDetail from '@/components/TaskDetail.vue'
import Profile from '@/components/Profile.vue'
import Settings from '@/components/Settings.vue'
import StudentProfile from '@/components/StudentProfile.vue'
import Challenges from '@/components/Challenges.vue'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/challenges',
    name: 'Challenges',
    component: Challenges
  },
  {
    path: '/student/:id',
    name: 'StudentProfile',
    component: StudentProfile,
    props: true
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/register',
    name: 'Register',
    component: RegistrationPage
  },
  {
    path: '/verify-google-email',
    name: 'EmailVerification',
    component: EmailVerificationPage
  },
  {
    path: '/student-dashboard',
    name: 'StudentDashboard',
    component: StudentDashboard
  },
  {
    path: '/rewards',
    name: 'Rewards',
    component: RewardsPage
  },
  {
    path: '/library',
    name: 'Library',
    component: LibraryPage
  },
  {
    path: '/activity',
    name: 'Activity',
    component: ActivityPage
  },
  {
    path: '/language-learning',
    name: 'LanguageLearning',
    component: LanguageLearningPage
  },
  {
    path: '/puzzle-game',
    name: 'PuzzleGame',
    component: PuzzleGame
  },
  {
    path: '/reflection',
    name: 'Reflection',
    component: ReflectionPage
  },
  {
    path: '/challenges/:id',
    name: 'ChallengeDetail',
    component: ChallengeDetail,
    props: true
  },
  {
    path: '/tasks/:id',
    name: 'TaskDetail',
    component: TaskDetail,
    props: true
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings
  },
  {
    path: '/teacher-dashboard',
    name: 'TeacherDashboard',
    component: TeacherDashboard
  },
  {
    path: '/parent-dashboard',
    name: 'ParentDashboard',
    component: ParentDashboard
  },
  // Catch-all: redirect unknown routes to student dashboard or login
  {
    path: '/:pathMatch(.*)*',
    redirect: () => {
      const hasUser = typeof localStorage !== 'undefined' && !!localStorage.getItem('currentUser')
      return hasUser ? '/student-dashboard' : '/login'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router 